import React, { FC } from 'react';
import { NavLink, LinkLabel, IconContainer } from './styles';
import { Props } from './types';

const LinkMenu: FC<Props> = ({ to, label, icon, ...props }) => {
  return (
    <NavLink to={to} activeClassName="selected" {...props}>
      <IconContainer>{icon}</IconContainer>
      <LinkLabel>{label}</LinkLabel>
    </NavLink>
  );
};

export default LinkMenu;
